// NotesApp - global dialog service
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum DialogType {
    Loading = 'loading',
    Info = 'info',
    Error = 'error',
    Warning = 'warning'
}

// global-dialog.service.ts
@Injectable({ providedIn: 'root' })
export class GlobalDialogService {
    private _visible$ = new BehaviorSubject<boolean>(false);
    visible$ = this._visible$.asObservable();

    title = '';
    message = '';
    details = '';
    type: DialogType = DialogType.Info;

    private buffer: {
        title: string;
        message: string;
        details: string;
        type: DialogType;
    } | null = null;

    private isComponentReady = false;

    notifyReady() {
        this.isComponentReady = true;
        if (this.buffer) {
            this._showBufferedDialog();
        }
    }

    showGlobalDialog(title: string, message = '', details = '', type: DialogType = DialogType.Info) {
        if (type === DialogType.Error) {
            console.error(`GlobalDialogService: showGlobalDialog called with title: ${title}, message: ${message}, details: ${details}, type: ${type}`);
    
        } else {
            console.log(`GlobalDialogService: showGlobalDialog called with title: ${title}, message: ${message}, details: ${details}, type: ${type}`);
        }
        if (!this.isComponentReady) {
            this.buffer = { title, message, details, type };
            return;
        }

        this.title = title;
        this.message = message;
        this.details = details;
        this.type = type;
        this._visible$.next(true);
    }

    private _showBufferedDialog() {
        if (!this.buffer) return;
        this.showGlobalDialog(this.buffer.title, this.buffer.message, this.buffer.details, this.buffer.type);
        this.buffer = null;
    }

    hide() {
        this._visible$.next(false);
    }
}